// extracted by mini-css-extract-plugin
module.exports = {"timerInput":"timer-input_timerInput__IB2AH","inputField":"timer-input_inputField__fxRKa","changeTimeButton":"timer-input_changeTimeButton__U02M1"};